import { Button, Flex, ModalBody, ModalContent, ModalOverlay, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface ISettingsDeleteAddressModalProps {
  onClose: () => void;
  onDelete: () => void;
}

export const SettingsDeleteAddressModal: React.FC<ISettingsDeleteAddressModalProps> = (
  props
): JSX.Element => {
  const { t } = useTranslation();

  const deleteHandler = (): void => {
    props.onDelete();
  };

  return (
    <ModalOverlay backdropFilter="blur(10px) hue-rotate(90deg)" bg="grey">
      <ModalContent
        borderRadius={0}
        minH={{ base: '200px', md: '300px' }}
        minW={{ base: 'full', md: '50%' }}
      >
        <ModalBody overflow="hidden" p={20} paddingInlineEnd={0} paddingInlineStart={0}>
          <Flex alignItems="center" direction="column" gap={8} justifyContent="center">
            <Text fontSize={18}>{t('ACCOUNT.SETTINGS.DELETE_ADDRESS.TITLE')}</Text>
            <Button variant="mbePrimary" onClick={deleteHandler}>
              <Text fontSize={14} w="100px">
                {t('ACCOUNT.SETTINGS.DELETE_ADDRESS.YES')}
              </Text>
            </Button>
            <Button variant="mbeSecondary" onClick={props.onClose}>
              <Text fontSize={14} w="100px">
                {t('ACCOUNT.SETTINGS.DELETE_ADDRESS.NO')}
              </Text>
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </ModalOverlay>
  );
};
